import { NotFound } from '@/components';
import type { FC } from 'react';

export const PermissionDenied: FC = () => {
  // TODO: replace with a proper permission denied component
  return <NotFound height="100vh" />;
};
